import { PROJECT_AGREEMENTS_REQUEST, PROJECT_AGREEMENTS, PROJECT_AGREEMENTS_LOADED, PROJECT_AGREEMENTS_CLEAR,
	PROJECT_AGREEMENTS_FAIL} from "../store/config";

const agreementsInit = {
	isFetching: false,
	data: {},
	documents_items:[],
	revisions:[],
	permissions: [],
	version: {},
	error: undefined,
	timestamp: undefined
}

const agreements = (state = agreementsInit, action) => {
	switch (action.type) {
		case PROJECT_AGREEMENTS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECT_AGREEMENTS:
			return {
				...state,
				isFetching: action.isFetching,
				data: action.payload,
				documents_items: action.documents_items,
				editable: action.editable,
				revisions: action.revisions,
				permissions: action.permissions,
				version: action.version,
				timestamp: action.timestamp
			}
		case PROJECT_AGREEMENTS_LOADED:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECT_AGREEMENTS_CLEAR:
			return {
				...state,
				data: action.payload,
				timestamp: action.timestamp
			}
		case PROJECT_AGREEMENTS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default agreements;


// WEBPACK FOOTER //
// ./src/reducers/agreements.js